import LogoImage from './assets/Logo.png';

// Logo.png (565x315) artwork alpha bounds are x 12..548, y 9..302, so the
// visible "VAI" mark ends at ~97% of the image width and starts ~3% down.
// The ™ is anchored just past that top-right corner.
export const TM_LEFT = '96%';
export const TM_TOP = '2%';

// ™ glyph size as a fraction of the rendered logo width.
export const TM_WIDTH_RATIO = 0.1;
const LOGO_ASPECT = 565 / 315;

// Derive a px font size for the ™ from whichever logo dimension the caller
// controls (width or height). Floors at 9px so it stays legible on phones.
export const tmFontSize = ({ width, height }) => {
  const w = typeof width === 'number' ? width : height * LOGO_ASPECT;
  return Math.max(9, Math.round(w * TM_WIDTH_RATIO));
};

/**
 * TrademarkLogo
 *
 * Renders the VAI logo image with a ™ overlaid on its top-right corner via
 * CSS, so the mark stays crisp at any size and Logo.png stays untouched.
 * `imgStyle`/`imgProps` pass straight through to the <img>; `tmSize` is any
 * CSS font-size (use tmFontSize() for px-sized logos, or a vw clamp for
 * viewport-sized ones).
 */
const TrademarkLogo = ({ imgStyle, imgProps = {}, tmSize, wrapperStyle, className }) => (
  <span
    className={className}
    style={{ position: 'relative', display: 'inline-block', lineHeight: 0, ...wrapperStyle }}
  >
    <img src={LogoImage} alt="Vicktoria AI™ Logo" style={imgStyle} {...imgProps} />
    <span
      data-testid="logo-tm"
      aria-hidden="true"
      style={{
        position: 'absolute',
        left: TM_LEFT,
        top: TM_TOP,
        fontSize: tmSize,
        lineHeight: 1,
        fontWeight: 700,
        fontFamily: 'Inter, sans-serif',
        color: '#2B4B6F',
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      ™
    </span>
  </span>
);

export default TrademarkLogo;
